export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9483.75f25a75.jpg";